// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"42dd03e3","134":"270cac89","147":"3c736735","152":"fa035ec4","198":"5c830e18","362":"b5d303b4","404":"3ac5f455","480":"f1f63c84","541":"d9887435","579":"e9a96861","747":"f0ccc480","854":"1cd05b44"}[chunkId] + ".chunk.js";
};